<template>
  <el-dialog class="tpl-word-dialog" @click.stop :fullscreen="true" :modal="false" @closed="onDialogClosed"
             :title="`编辑表格 - 建议内容宽高(${data.width}x${data.height})`"
             width="100%"
             :visible.sync="dialogVisible">
    <div class="twd-body" :style="getBodyWidth">
      <div class="twd-content">
        <div class="twd-c-body"  v-loading="fontLoading"
             element-loading-text="正在加载中..."
             element-loading-spinner="el-icon-loading">
          <textarea id="mytextarea" name="mytextarea"></textarea>
        </div>
        <div class="twd-aside">
          <el-tabs  v-model="activeName">
            <el-tab-pane label="系统样式" name="1">
              <table-theme></table-theme>
            </el-tab-pane>
            <el-tab-pane label="项⽬样式" name="2">
              <div class="def-theme-box">
                <ul>
                  <li v-for="(item, index) in defaultData" :key="item.id" @click="onAsideClick(item)"
                      :class="{'active': item.id === activeId}">
                    <i  class="theme-checkbox el-icon-success"
                        :class="{active: item.id === activeId}"></i>
                    <div class="img-box">
                      <img :src="item.viewImg"/>
                    </div>
                    <p>默认表格{{index + 1}}</p>
                    <span class="th-tools twd-del-btn" @click.stop="onDelTemplateWord(item)"
                          v-if="$store.getters['app/isSYSAdmin']">
                            <i class="el-icon-delete"></i>
                    </span>

                  </li>
                </ul>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div style="height: 0px; overflow: auto">
        <word-to-img ref="wordImgRef" :key="domToimgKey" :bg-color="bgColor" :html-str="imgData" :w-width="data.width"></word-to-img>
      </div>
      <div class="twd-c-footer">
        <template v-if="isThemeMode">
          <el-button type="primary" round @click="onUpdateTheme" :loading="loading"
                     v-if="$store.getters['app/isSYSAdmin']">确认
          </el-button>
          <el-button type="default" round @click="onCloseTheme">取消</el-button>
        </template>
        <template v-else>
          <el-button type="default" round @click="onSaveTemplateWord" :loading="loading"
                     v-if="$store.getters['app/isSYSAdmin']">设为表格模板
          </el-button>
          <el-button type="primary" round @click="onConfirm" :loading="confirmLoading">确认</el-button>
          <el-button type="default" round @click="onClose">取消</el-button>
        </template>
      </div>
    </div>
    <el-dialog class="tpl-word-img-dialog" :modal="false"
               title="插入图片"
               width="500px"
               :visible.sync="imgDialogVisible">
      <div style="min-height: 40px">
        <ul v-if="imgList.length > 0">
          <li v-for="item in imgList" :key="item.id">
            <div class="img-box" @click="onClickImg(item)">
              <img :src="item.url"/>
            </div>
            <p>{{item.widthHeight}}</p>
            <p :title="item.name">{{item.name}}</p>
          </li>
        </ul>
        <p v-else class="c-center c-gray">无可用素材</p>
      </div>
    </el-dialog>
  </el-dialog>
</template>
<script>
    import templateService from '@/request/service/template-service';
    import wordToImg from './word-to-img'
    import materialService from '../../../request/service/material-service';
    import {material_type} from '@/const.js';
    import util from '@/util.js';
    import {default_table_html} from './table-html'
    import TUtil from "../TUtil";
    import tableTheme from './tableTheme/table-theme-index'
    const tinymce_selector = '#mytextarea';
    const tinymce_margin_idth = 20;
    export default {
        components: {wordToImg, tableTheme},
        props: {
            value: {
                type: Boolean, default: false
            },
            data: Object, // 管理员修改表格数据或设置默认表格
            themeData: Object, //管理员修改表格样式时使用
            projectId: String,
            currentTemplateId: String,
            templateIds: Array,
        },
        data () {
            return {
                imgData: '',
                confirmLoading: false,
                loading: false,
                activeId: null,
                domToimgKey: 0,
                imgDialogVisible: false,
                materialPage: {
                    projectId: null,
                    nameOrTagName: '表格',
                    type: material_type.element,
                    pageSize: 20,
                    pageNum: 1,
                    widthHeights: null, // ['100x200', '255x300']
                    tagNames: [],
                },
                imgList: [],
                themeItem: {},
                fontLoading: false,
                bgColor: null,
                activeName: '1'
            }
        },
        computed: {
            dialogVisible: {
                get () {
                    return this.value;
                },
                set (v) {
                    this.$emit('input', v);
                }
            },
            getBodyWidth () {
                return `width: ${+this.data.width + tinymce_margin_idth + 280}px`
            },
            isThemeMode () { // 用来区分是表格样式修改还是模板表格内容修改
                return this.themeItem && this.themeItem.id
            },
            defaultData () {
                return this.$store.state.templateGroup.tableThemeList;
            }
        },
        watch: {
            dialogVisible: {
                handler (v) {
                    if (v) {
                        this.$nextTick(() => {
                            this.init()
                        })
                    }
                },
                immediate: true
            }
        },
        destroyed(){
            this.activeId = null;
        },
        methods: {
            init () {
                this.themeItem = Object.assign({}, this.themeData);
                this.getWordTableList();
                this.initEditor();
            },
            initEditor () {
                let self = this;
                let fontStr = this.getFontString();
                let fontSizeStr = this.getFontSizeList();
                let width = +this.data.width || 300;
                width += tinymce_margin_idth;
                let defFontFamily = this.data.fontFamily || '';
                if (!tinymce.activeEditor) {
                    tinymce.init({
                        selector: tinymce_selector,
                        language: 'zh_CN',
                        language_url: 'js/tinymce/langs/zh_CN.js',
                        content_css: 'js/tinymce/tinymce-reset.css, js/tinymce/tinymce-table.css',
                        content_style: `table{font-family: ${defFontFamily}`,
                        branding: false,
                        menubar: false,
                        statusbar: false,
                        elementpath: false,
                        theme_advanced_resizing: true,
                        min_height: 200,
                        width: width,
                        plugins: "table fullscreen paste lineheight advlist lists autoresize",
                        paste_retain_style_properties: "all",
                        fontsize_formats: fontSizeStr,
                        font_formats: fontStr,
                        toolbar: ["fontsizeselect fontselect lineheight forecolor backcolor bold italic underline strikethrough ," +
                        " alignleft aligncenter alignright alignjustify," +
                        " table tabledelete tableprops tablerowprops tablecellprops tableinsertrowbefore tableinsertrowafter tabledeleterow tableinsertcolbefore tableinsertcolafter tabledeletecol insertImg pastetext fullscreen resizeTable"],
                        setup: (editor) => {
                            editor.ui.registry.addButton('insertImg', {
                                icon: 'image',
                                tooltip: '插入图片',
                                onAction: () => {
                                    self.imgDialogVisible = true;
                                    self.getMaterialList();
                                }
                            });
                            editor.on('init', () => {
                                this.setContentForInit();
                                this.onExecCommand(tinymce.activeEditor);
                            });
                            editor.on('load', (e) => {
                                this.initFontInFrame(e.target.iframeElement.contentWindow, this.getTextFontList());
                            });
                        },
                    });
                } else {
                    this.setContentForInit();
                    this.onExecCommand(tinymce.activeEditor);
                }
            },
            getFontString () {
                let list = this.$store.state.app.projectFontList.map((item) => {
                    return `${item.name}=${item.name},PingFang SC,Microsoft YaHei,sans-serif`;
                });
                return list.join(';');
            },
            getFontSizeList () {
                let arr = [];
                for (let i = 12; i <= 50; i++) {
                    arr.push(`${i}px`);
                }
                return arr.join(' ');
            },
            setContentForInit () {
                if (this.isThemeMode) {
                    tinymce.activeEditor.setContent(this.themeItem.html);
                } else {
                    tinymce.activeEditor.setContent(this.data.htmlStr || default_table_html.join(''));
                }
            },
            onExecCommand (activeEditor) {
                activeEditor.on('ExecCommand', (e) => {
                    if (e.command === 'FontName') {
                        this.saveFont(e.value);
                        this.downloadFontBySetFontFamily([e.value.split(',')[0]]);
                    }
                });
            },
            getTextFontList(){
                let fontStr = this.data.fontFamily;
                if(!fontStr){
                    return [];
                }
                let projectFontList = this.$store.state.app.projectFontList, fontMap = {},
                    fontObjList = [],
                    missingFontList = [],
                    fontNameList = Array.from(new Set(fontStr.split(',')));
                projectFontList.map((item) => {
                    fontMap[item.name] = item;
                });
                fontNameList.forEach((name) => {
                    if(fontMap[name]){
                        fontObjList.push(fontMap[name]);
                    }else{
                        missingFontList.push(name);
                    }
                });
                /**
                 * 没有在富文本中设置过字体，提示字体缺失，通过图层上的fontFamily判断字体。
                 * 如果整个富文本更新成同一个字体，此处缺字体判断会无效，添加setFontByWord 跳过判断
                 */
                if(missingFontList.length > 0 && !this.data.setFontByWord){
                    this.$message({
                        type: 'error',
                        message: `富文本编辑器缺失字体: ${missingFontList.join(',')}, 请到后台项目字体管理中添加字体`,
                        duration: 0,
                        showClose: true
                    })
                }
                return fontObjList;
            },
            async initFontInFrame(iframeWin, fontList){
                this.fontLoading = true;
                let item;
                for(let i in fontList){
                    item = fontList[i];
                    await this.downloadFontByUrl(iframeWin, item.name, item.url);
                }
                this.fontLoading = false;
            },
            downloadFontByUrl(iframeWin, name, url){
                let fontFace = new iframeWin.FontFace(name, `url(${url})`);
                return new Promise((resolve, reject) => {
                    fontFace.load().then((font) => {
                        iframeWin.document.fonts.add(font);
                        resolve(true);
                    }).catch((error) => {
                        console.error(`字体解析异常：${name}`);
                        reject(error);
                    });
                });
            },
            downloadFontBySetFontFamily(fontList){
                let fontArr = this.$store.state.app.projectFontList.filter((item) => {
                    return fontList.indexOf(item.name) > -1
                });
                let frameWindow = document.querySelector(`${tinymce_selector}_ifr`).contentWindow;
                util.insertFontStyle(fontArr, frameWindow);
            },
            saveFont(fontStr){
                let fontFamily = this.data.fontFamily, fontList;
                let curFont = fontStr.split(',')[0];
                fontList = fontFamily ? fontFamily.split(',') : [];
                fontList = Array.from(new Set(fontList));
                let hasFont = fontList.some((name) => {
                    return name === curFont;
                });
                if(!hasFont){
                    fontList.push(curFont);
                }
                this.data.fontFamily = fontList.join(',');
                this.data.setFontByWord = true;
            },
            getWordTableList () {
                let params = {
                    templateIds: this.templateIds,
                    projectId: this.projectId
                };
                templateService.getTemplateWordList(params).then((data) => {
                    this.$store.commit('templateGroup/set_table_theme', data.list || []);
                    this.setActiveAside()
                });
            },
            setActiveAside () {
                if (this.themeItem && this.themeItem.id) {
                    this.activeId = this.themeItem.id;
                }
            },
            onClose () {
                this.dialogVisible = false;
            },
            _insertImg (imgUrl) {
                if (tinymce.activeEditor) {
                    tinymce.activeEditor.execCommand('mceInsertContent', false, `<img src="${imgUrl}">`);
                }
            },
            setWidth () {
                let widthArr = document.querySelectorAll('.word-to-img table td');
                let width, fontSize;
                for (let i = 0; i < widthArr.length; i++) {
                    width = widthArr[i].style.width;
                    if (width.indexOf('pt') > -1) {
                        width = +width.split('pt')[0];
                        widthArr[i].style.width = width * (4 / 3) + 'px';
                    }
                }
                let fontSizeArr = document.querySelectorAll('.word-to-img table span');
                for (let i = 0; i < fontSizeArr.length; i++) {
                    fontSize = fontSizeArr[i].style.fontSize;
                    if (fontSize.indexOf('pt') > -1) {
                        fontSize = +fontSize.split('pt')[0];
                        fontSizeArr[i].style.fontSize = fontSize * (4 / 3) + 'px';
                    }
                }
            },
            getImg () {
                let content = this.getContent();
                this.domToimgKey += 1;
                this.imgData = content;
                return TUtil.tableToImg(this, content);
            },
            setTableStyle(){
                let pTable = tinymce.activeEditor.getBody().querySelector('.t-round');
                // this.bgColor = pTable ? 'rgba(0,0,0,0)': '#fff';
                this.data.borderRadius = pTable ? 10 : 0;
            },
            onConfirm () {
                this.setTableStyle();
                let content = this.getContent();
                if (content) {
                    this.confirmLoading = true;
                    this.getImg().then((data) => {
                        this.$emit('onConfirm', data);
                    }).finally(() => {
                        this.dialogVisible = false;
                        this.confirmLoading = false;
                    });
                } else {
                    this.$message.error('表格内容不能为空')
                }
            },
            onUpdateTheme () {
                if (this.themeItem.id) {
                    templateService.deleteTemplateWord([this.themeItem.id], this.projectId).then(() => {
                        this.saveTemplateWord(() => {
                            this.onCloseTheme();
                        });
                    });
                }
            },
            onCloseTheme () {
                this.dialogVisible = false;
                this.$emit('onCloseThemeDialog')
            },
            onSaveTemplateWord () {
                this.saveTemplateWord();
            },
            getContent () {
                let content = tinymce.activeEditor.getContent().trim();
                if (content) {
                    let lastEmptyStr = '<p>&nbsp;</p>';
                    let str = content.substring(content.length - lastEmptyStr.length);
                    if (str === lastEmptyStr) {
                        return content.substring(0, content.length - lastEmptyStr.length);
                    } else {
                        return content;
                    }
                } else {
                    return content;
                }
            },
            saveTemplateWord (cb) {
                let content = this.getContent();
                if (!content) {
                    this.$message.error('内容不能为空');
                    return;
                }
                this.loading = true;
                this.getImg().then(({url, htmlStr}) => {
                    this.saveTemplate(url, htmlStr, cb);
                }).finally(() => {
                    this.loading = false;
                });
            },
            saveTemplate (url, content, cb) {
                let data = {
                    viewImg: url,
                    html: content,
                    projectId: this.projectId,
                    templateId: this.currentTemplateId
                }
                templateService.saveTemplateWord(data).then(() => {
                    this.$message.success('保存成功');
                    this.getWordTableList();
                    cb && cb();
                }).finally(() => {
                    this.loading = false;
                })
            },
            onAsideClick (item) {
                if (this.isThemeMode) {
                    this.themeItem = item;
                }
                this.activeId = item.id;
                tinymce.activeEditor.setContent(item.html || '');
                this.eventBus.$emit('_clearActiveThemeStatus');
            },
            onDelTemplateWord (item) {
                templateService.deleteTemplateWord([item.id], this.projectId).then(() => {
                    this.$message.success('删除成功');
                    this.getWordTableList();
                })
            },
            onDialogClosed () {
                tinymce.remove('#mytextarea');
                tinymce.activeEditor = null;
            },
            getMaterialList () {
                let materialPage = this.materialPage;
                materialPage.projectId = this.projectId;
                materialService.getMaterialList(materialPage).then(({list}) => {
                    this.imgList = list
                });
            },
            onClickImg (item) {
                this._insertImg(item.url);
                this.imgDialogVisible = false;
            },
        }
    }
</script>
<style lang="css">
  @import "../../../../public/js/tinymce/tinymce-table.css";
</style>
<style lang="scss">
  @import "./tpl-word-dialog";
</style>